import React from 'react';

const ProgressIndicator = ({ 
  value = 0, 
  max = 100, 
  label = '', 
  showPercentage = true,
  color = 'primary',
  size = 'default',
  className = '' 
}) => {
  const percentage = Math.min(Math.max((value / max) * 100, 0), 100);
  
  const sizeClasses = {
    sm: 'h-1',
    default: 'h-2',
    lg: 'h-3'
  };

  const colorStyles = {
    primary: 'linear-gradient(90deg, var(--color-primary) 0%, var(--color-accent) 100%)',
    success: 'var(--color-success)',
    warning: 'var(--color-warning)',
    error: 'var(--color-error)',
  };

  return (
    <div className={`progress-indicator ${className}`}>
      {(label || showPercentage) && (
        <div className="progress-indicator-label">
          {label && <span>{label}</span>}
          {showPercentage && (
            <span className="progress-indicator-percentage">
              {Math.round(percentage)}%
            </span>
          )}
        </div>
      )}
      <div className={`progress-indicator-track ${sizeClasses?.[size]}`}>
        <div
          className="progress-indicator-bar"
          style={{
            width: `${percentage}%`,
            background: colorStyles?.[color]
          }}
        />
      </div>
    </div>
  );
};

export default ProgressIndicator;